<template>
  <div class="home_container flex-center">
    <div class="wrapper">
      <!-- <iframe frameborder=0 style="width:100%;height:100%" src="https://www.gaokaowin.com/huixuebao/disk/"></iframe> -->
      <network-disk :fileType="fileType" :boxHeight="800" style="width: 1200px;" />
      <resource-high   />
    </div>
  </div>
</template>
<script>

export default {

  data() {
    return {
      fileType: [{
        name: '文件',
        value: 'application',
        isShow: true,
        icon: 'el-icon-document-remove',
      }, {
        name: '图片',
        value: 'image',
        isShow: true,
        icon: 'el-icon-picture-outline',
      }, {
        name: '音频',
        value: 'audio',
        isShow: true,
        icon: 'el-icon-headset',
      }, {
        name: '视频',
        value: 'video',
        isShow: true,
        icon: 'el-icon-video-camera',
      }, {
        name: '备课包',
        value: 'lessonPreparationKit',
        isShow: false,
        icon: 'el-icon-document-remove',
      }, {
        name: '教案',
        value: 'teachingPlan',
        isShow: false,
        icon: 'el-icon-notebook-2',
      }, {
        name: '导学案',
        value: 'learningGuidePlan',
        isShow: false,
        icon: 'el-icon-notebook-1',
      }, {
        name: '作业',
        value: 'work',
        isShow: false,
        icon: 'el-icon-tickets',
      }, {
        name: '其他',
        value: 'other',
        isShow: true,
        icon: 'el-icon-menu',
      }]
    };
  },
  watch: {},

  mounted() {

  },
  methods: {

  },
};
</script>
<style  ></style>

<style >
.wrapper {
  box-sizing: border-box;
  margin: 14px auto;
  /* background:#ffffff; */
  height: calc(100vh - 152px);
  overflow: auto;
  border-radius: 12px;
  overflow: hidden;
  min-width: 1200px;
  /* padding:20px 0; */
}
</style>


